import {
  BpkAccordion,
  BpkAccordionItem,
  withAccordionItemState,
} from '@skyscanner-internal/backpack-web/bpk-component-accordion';
import {
  BpkBox,
  BpkVessel,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkLink from '@skyscanner-internal/backpack-web/bpk-component-link';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import type { CustomNavMenuItem } from '@skyscanner-internal/landing-pages-shared-types/types-shared/CustomNavProps';

import STYLES from './CustomNav.module.scss';

type CustomNavMobileItemProps = {
  menuItem: CustomNavMenuItem;
  mobileVisitParentPageLabel: string;
};

const StatefulAccordionItem = withAccordionItemState(BpkAccordionItem);

export default function CustomNavMobileItem({
  menuItem,
  mobileVisitParentPageLabel,
}: CustomNavMobileItemProps) {
  if (!menuItem.subMenuItems?.length) {
    return (
      <BpkVessel key={menuItem.id} className={STYLES.SingleMenuItem}>
        <BpkText textStyle={TEXT_STYLES.bodyLongform}>
          <BpkLink href={menuItem.href} alternate>
            {menuItem.label}
          </BpkLink>
        </BpkText>
      </BpkVessel>
    );
  }

  return (
    <BpkAccordion key={menuItem.id} onDark>
      <StatefulAccordionItem
        id={menuItem.id}
        title={menuItem.label}
        textStyle="body-longform"
      >
        <BpkBox>
          <BpkVessel className={STYLES.SubMenuItem}>
            <BpkLink href={menuItem.href} alternate>
              {mobileVisitParentPageLabel.replace('@@title@@', menuItem.label)}
            </BpkLink>
          </BpkVessel>

          {menuItem.subMenuItems.map((subMenuItem) => (
            <BpkVessel key={subMenuItem.id} className={STYLES.SubMenuItem}>
              <BpkLink href={subMenuItem.href} alternate>
                {subMenuItem.label}
              </BpkLink>
            </BpkVessel>
          ))}
        </BpkBox>
      </StatefulAccordionItem>
    </BpkAccordion>
  );
}
